import { createContext, useContext } from 'react'
import { User } from '../types'
import { useRealAuth } from '../hooks/useRealAuth'

interface AuthContextType {
 user: User | null
 token: string | null
 login: (email: string, password: string) => Promise<void>
 logout: () => void
 isLoading: boolean
 isAuthenticated: boolean
 updateUser: (newUserData: Partial<User>) => void
 isTokenValid: () => boolean
 refreshAccessToken: () => Promise<boolean>
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

interface AuthProviderProps {
 children: React.ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
 // Usa o auth real com API
 const realAuth = useRealAuth()

 const value: AuthContextType = {
 user: realAuth.user,
 token: realAuth.token,
 login: realAuth.login,
 logout: realAuth.logout,
 isLoading: realAuth.isLoading,
 isAuthenticated: realAuth.isAuthenticated,
 updateUser: realAuth.updateUser,
 isTokenValid: realAuth.isTokenValid,
 refreshAccessToken: realAuth.refreshAccessToken,
 }

 console.log('🔍 AuthContext state atualizado:', {
 user: realAuth.user,
 token: realAuth.token,
 isAuthenticated: realAuth.isAuthenticated,
 isLoading: realAuth.isLoading,
 isTokenValid: realAuth.isTokenValid()
 })


 return (
 <AuthContext.Provider value={value}>
 {children}
 </AuthContext.Provider>
 )
}

export const useAuth = (): AuthContextType => {
 const context = useContext(AuthContext)
 if (context === undefined) {
 throw new Error('useAuth must be used within an AuthProvider')
 }
 return context
}
